{
  "admission": "รับเข้ารักษา",
  "transfer": "ย้ายหอผู้ป่วย",
  "visit": "การเข้าพบ",
  "type": "ประเภทการเข้ารับบริการ",
  "status": "สถานะ",
  "location": "สถานที่",
  "attendingPhysician": "แพทย์เจ้าของไข้",
  "admitDate": "วันที่รับเข้า",
  "dischargeDate": "วันที่จำหน่าย",
  "chiefComplaint": "อาการสำคัญ",
  "diagnosis": "การวินิจฉัย",
  "class": {
    "label": "ประเภท",
    "values": {
      "emergency": "ฉุกเฉิน",
      "inpatient": "ผู้ป่วยใน",
      "outpatient": "ผู้ป่วยนอก",
      "observation": "สังเกตอาการ",
      "ambulatory": "บริการรายวัน",
      "homeHealth": "การดูแลที่บ้าน",
      "virtual": "การแพทย์ทางไกล"
    }
  },
  "statusValues": {
    "label": "สถานะ",
    "values": {
      "pending": "รอดำเนินการ",
      "arrived": "มาถึงแล้ว",
      "active": "กำลังดำเนินการ",
      "completed": "เสร็จสิ้น",
      "cancelled": "ยกเลิก"
    }
  },
  "admissionSource": {
    "label": "ที่มาของการรับเข้า",
    "none": "—",
    "values": {
      "emergency": "แผนกฉุกเฉิน",
      "clinicReferral": "ส่งต่อจากคลินิก",
      "physicianReferral": "ส่งต่อโดยแพทย์",
      "transfer": "ย้ายจากสถานพยาบาลอื่น",
      "self": "มาเอง / เดินเข้า",
      "courtLaw": "ศาล / เจ้าหน้าที่ตำรวจ"
    }
  },
  "admissionType": {
    "label": "ประเภทการรับเข้า",
    "none": "—",
    "values": {
      "elective": "นัดล่วงหน้า",
      "emergency": "ฉุกเฉิน",
      "urgent": "เร่งด่วน",
      "newborn": "ทารกแรกเกิด",
      "trauma": "บาดเจ็บรุนแรง"
    }
  },
  "acuity": {
    "label": "ระดับความรุนแรง",
    "none": "—",
    "values": {
      "1": "1 — กู้ชีพ",
      "2": "2 — วิกฤต",
      "3": "3 — เร่งด่วน",
      "4": "4 — กึ่งเร่งด่วน",
      "5": "5 — ไม่เร่งด่วน"
    },
    "shortValues": {
      "1": "กู้ชีพ",
      "2": "วิกฤต",
      "3": "เร่งด่วน",
      "4": "กึ่งเร่งด่วน",
      "5": "ไม่เร่งด่วน"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "การเข้ารับบริการใหม่",
    "subtitle": "เริ่มการเข้ารับบริการ / การรับเข้ารักษาใหม่สำหรับผู้ป่วยรายนี้",
    "sections": {
      "visit": "ข้อมูลการเข้ารับบริการ",
      "reasonForVisit": "เหตุผลในการเข้ารับบริการ",
      "admission": "ข้อมูลการรับเข้า"
    },
    "fields": {
      "facility": "สถานพยาบาล",
      "encounterClass": "ประเภทการเข้ารับบริการ",
      "encounterType": "ชนิดการเข้ารับบริการ",
      "department": "แผนก",
      "attendingProvider": "แพทย์เจ้าของไข้",
      "acuity": "ระดับความรุนแรง",
      "visitReason": "เหตุผลในการเข้ารับบริการ",
      "chiefComplaint": "อาการสำคัญ",
      "admissionSource": "ที่มาของการรับเข้า",
      "admissionType": "ประเภทการรับเข้า"
    },
    "placeholders": {
      "selectFacility": "เลือกสถานพยาบาล",
      "none": "—",
      "encounterType": "เช่น ตรวจสุขภาพประจำปี, ER",
      "visitReason": "ป้ายสั้น ๆ เช่น ตรวจติดตาม, ตรวจสุขภาพประจำปี",
      "chiefComplaint": "เหตุผลที่ผู้ป่วยระบุด้วยคำของตนเอง"
    },
    "providerFallback": "แพทย์ #{{id}}",
    "submit": "สร้างการเข้ารับบริการ",
    "validation": {
      "facilityRequired": "กรุณาเลือกสถานพยาบาล",
      "encounterClassRequired": "กรุณาเลือกประเภทการเข้ารับบริการ"
    },
    "createdSuccess": "สร้างการเข้ารับบริการแล้ว",
    "createError": "ไม่สามารถสร้างการเข้ารับบริการได้"
  },
  "detail": {
    "loading": "กำลังโหลดข้อมูลการเข้ารับบริการ...",
    "notFound": "ไม่พบการเข้ารับบริการ",
    "loadError": "โหลดข้อมูลการพบแพทย์ไม่สำเร็จ",
    "retry": "ลองอีกครั้ง",
    "returnToDashboard": "กลับไปยังแดชบอร์ด",
    "header": {
      "title": "การเข้ารับบริการ {{number}}",
      "facilityLabel": "สถานพยาบาล #{{id}}",
      "departmentLabel": "แผนก #{{id}}",
      "locationLabel": "ตำแหน่ง #{{id}}",
      "admittedLabel": "รับเข้า: {{datetime}}"
    },
    "actions": {
      "transfer": "ย้ายหอผู้ป่วย",
      "discharge": "จำหน่าย"
    },
    "tabs": {
      "overview": "ภาพรวม",
      "orders": "คำสั่งการรักษา",
      "results": "ผลตรวจ",
      "medications": "ยา",
      "notes": "บันทึก",
      "billing": "การเงิน"
    },
    "overview": {
      "chiefComplaint": "อาการสำคัญ",
      "visitReason": "เหตุผลในการเข้ารับบริการ",
      "attendingProvider": "แพทย์เจ้าของไข้",
      "acuityLevel": "ระดับความรุนแรง",
      "providerFallback": "แพทย์ #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "ไทม์ไลน์เหตุการณ์",
      "empty": "ยังไม่มีเหตุการณ์ที่บันทึกไว้",
      "admittedTitle": "รับเข้า",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "ไม่มีอาการสำคัญ",
      "orderTitle": "คำสั่ง: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "ผล: {{type}}"
    },
    "orders": {
      "title": "คำสั่งการรักษา",
      "newOrder": "+ คำสั่งใหม่",
      "empty": "การเข้ารับบริการนี้ยังไม่มีคำสั่ง",
      "metaLine": "{{number}} | {{type}} | ความสำคัญ: {{priority}}"
    },
    "results": {
      "title": "ผลตรวจ",
      "empty": "การเข้ารับบริการนี้ยังไม่มีผลตรวจ",
      "criticalBadge": "วิกฤต",
      "viewLink": "ดู",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "ยา",
      "newMedication": "+ ยาใหม่",
      "empty": "การเข้ารับบริการนี้ยังไม่มีรายการยา",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "โมดูลบันทึกทางคลินิกจะเปิดใช้งานเร็ว ๆ นี้",
      "goToClinicalNotes": "ไปยังบันทึกทางคลินิก"
    },
    "billing": {
      "comingSoon": "โมดูลการเงินจะเปิดใช้งานเร็ว ๆ นี้"
    }
  },
  "census": {
    "title": "บอร์ดเตียง / รายชื่อผู้ป่วยใน",
    "subtitle": "สถานะเตียงและผู้ป่วยในแบบเรียลไทม์",
    "refresh": "รีเฟรช",
    "facilityName": "โรงพยาบาลทั่วไปสิงคโปร์",
    "capacitySummary": "ใช้งาน {{occupied}} / รวม {{total}} เตียง",
    "occupancyLabel": "อัตราการใช้ {{percent}}%",
    "stats": {
      "totalCapacity": "เตียงทั้งหมด",
      "occupied": "ใช้งาน",
      "available": "ว่าง",
      "pendingDischarge": "รอจำหน่าย"
    },
    "unitFilter": {
      "all": "ทุกหอผู้ป่วย",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "อายุรกรรม/ศัลยกรรม",
      "obs": "สังเกตอาการ",
      "peds": "กุมารเวช",
      "maternity": "สูติกรรม"
    },
    "roleView": {
      "nurse": "มุมมองพยาบาล",
      "physician": "มุมมองแพทย์",
      "bedManager": "มุมมองผู้จัดการเตียง"
    },
    "viewMode": {
      "grid": "มุมมองกริด",
      "table": "มุมมองตาราง"
    },
    "loading": "กำลังโหลดข้อมูลผู้ป่วยใน...",
    "columns": {
      "patient": "ผู้ป่วย",
      "mrn": "MRN",
      "admitDate": "วันที่รับเข้า",
      "status": "สถานะ",
      "acuity": "ระดับความรุนแรง",
      "isolation": "การแยกผู้ป่วย",
      "fallRisk": "ความเสี่ยงล้ม",
      "codeStatus": "รหัสกู้ชีพ",
      "chiefComplaint": "อาการสำคัญ",
      "attending": "แพทย์ผู้ดูแล",
      "los": "LOS",
      "locationBed": "ตำแหน่ง / เตียง",
      "transferStatus": "สถานะการย้าย",
      "expectedDischarge": "วันจำหน่ายที่คาด",
      "actions": "การจัดการ"
    },
    "values": {
      "unknownPatient": "ไม่ทราบ",
      "none": "ไม่มี",
      "notAvailable": "N/A",
      "pending": "รอดำเนินการ",
      "empty": "--",
      "providerFallback": "แพทย์ #{{id}}",
      "locationLabel": "ตำแหน่ง #{{id}}",
      "losDays": "{{days}} วัน"
    },
    "codeStatusTooltip": "รหัสกู้ชีพดูได้ที่แฟ้มผู้ป่วย",
    "actionsMenu": {
      "label": "การจัดการ",
      "viewChart": "ดูแฟ้มผู้ป่วย",
      "transfer": "ย้ายหอผู้ป่วย",
      "assignAttending": "มอบหมายแพทย์เจ้าของไข้",
      "discharge": "จำหน่าย"
    },
    "empty": "ไม่มีการเข้ารับบริการที่กำลังดำเนินการ",
    "department": {
      "filteredTo": "แสดงเฉพาะ {{name}}",
      "idLabel": "แผนก {{id}}",
      "showAll": "แสดงทุกแผนก"
    },
    "facility": {
      "label": "สถานพยาบาล",
      "allFacilities": "ทุกสถานพยาบาล",
      "idLabel": "สถานพยาบาล {{id}}"
    }
  },
  "discharge": {
    "label": "จำหน่าย",
    "title": "ขั้นตอนการจำหน่ายผู้ป่วย",
    "encounterLabel": "การเข้ารับบริการ {{number}}",
    "printButton": "พิมพ์เอกสารจำหน่าย",
    "loading": "กำลังโหลดการเข้ารับบริการ...",
    "notFound": "ไม่พบการเข้ารับบริการ",
    "returnToDashboard": "กลับสู่แดชบอร์ด",
    "notActive": "การเข้ารับบริการนี้ไม่ได้กำลังดำเนินการ (สถานะ: {{status}})",
    "backToEncounter": "กลับไปยังการเข้ารับบริการ",
    "progress": {
      "requiredMissingTooltip": "ยังกรอกข้อมูลที่จำเป็นไม่ครบ",
      "tasksRemainingTooltip": "ยังมีงานที่ค้างอยู่"
    },
    "steps": {
      "summary": "สรุปการจำหน่าย",
      "medications": "ยา",
      "followup": "นัดติดตาม",
      "instructions": "คำแนะนำ",
      "nursing": "งานพยาบาล",
      "signoff": "ลงนามโดยแพทย์เจ้าของไข้",
      "review": "ทบทวนและยืนยัน"
    },
    "summary": {
      "title": "สรุปการจำหน่าย",
      "diagnosisLabel": "การวินิจฉัยตอนจำหน่าย *",
      "diagnosisPlaceholder": "ป้อนการวินิจฉัยตอนจำหน่าย...",
      "diagnosisCodeLabel": "รหัสการวินิจฉัยตอนจำหน่าย (ICD-10)",
      "diagnosisCodePlaceholder": "ค้นหารหัส ICD-10...",
      "proceduresLabel": "หัตถการที่ได้รับ",
      "proceduresPlaceholder": "ระบุหัตถการที่ทำในการเข้ารับบริการครั้งนี้...",
      "conditionLabel": "อาการตอนจำหน่าย *"
    },
    "condition": {
      "values": {
        "stable": "คงที่",
        "improved": "ดีขึ้น",
        "unchanged": "ไม่เปลี่ยนแปลง",
        "worsened": "แย่ลง",
        "critical": "วิกฤต"
      }
    },
    "medications": {
      "title": "ยาที่จ่ายตอนจำหน่าย",
      "instructions": "ทบทวนยาแต่ละรายการและเลือก ใช้ต่อ หยุด หรือปรับ ตอนจำหน่าย",
      "actions": {
        "continue": "ใช้ต่อ",
        "stop": "หยุด",
        "modify": "ปรับ"
      },
      "modifiedPlaceholder": "ป้อนคำสั่งใช้ยาที่ปรับแล้ว...",
      "empty": "ไม่มียาที่ใช้งานอยู่สำหรับการเข้ารับบริการนี้"
    },
    "medAction": {
      "values": {
        "continue": "ใช้ต่อ",
        "stop": "หยุด",
        "modify": "ปรับ"
      }
    },
    "followup": {
      "title": "นัดติดตามอาการ",
      "providerLabel": "แพทย์ผู้นัดติดตาม",
      "providerPlaceholder": "ชื่อแพทย์หรือสาขา...",
      "dateLabel": "วันที่นัดติดตาม",
      "notesLabel": "หมายเหตุเพิ่มเติม",
      "notesPlaceholder": "หมายเหตุเพิ่มเติมเกี่ยวกับการติดตาม..."
    },
    "instructions": {
      "title": "คำแนะนำสำหรับผู้ป่วย",
      "generalLabel": "คำแนะนำทั่วไป",
      "generalPlaceholder": "คำแนะนำการจำหน่ายทั่วไปสำหรับผู้ป่วย...",
      "dietaryLabel": "คำแนะนำด้านอาหาร",
      "dietaryPlaceholder": "ข้อจำกัดหรือข้อแนะนำด้านอาหาร...",
      "activityLabel": "ข้อจำกัดด้านกิจกรรม",
      "activityPlaceholder": "ข้อจำกัดในการทำกิจกรรมทางร่างกาย...",
      "warningSignsLabel": "อาการเตือนที่ต้องเฝ้าระวัง",
      "warningSignsPlaceholder": "อาการที่ผู้ป่วยควรกลับมาพบแพทย์หรือเข้ารับการรักษา..."
    },
    "nursing": {
      "title": "งานพยาบาล",
      "instructions": "กรอกรายการตรวจสอบด้านล่างให้ครบก่อนจำหน่าย รายการเหล่านี้ใช้เพื่อบันทึกเท่านั้นและไม่เรียก API",
      "tasks": {
        "removeIv": "ถอดสาย IV",
        "discontinueMonitoring": "ยกเลิกเครื่องมือเฝ้าระวัง",
        "patientEducation": "ให้ความรู้แก่ผู้ป่วยเรียบร้อย",
        "medsReviewed": "ทบทวนยาตอนจำหน่ายกับผู้ป่วยแล้ว",
        "belongingsReturned": "คืนของส่วนตัวให้ผู้ป่วย",
        "transportArranged": "จัดเตรียมการเดินทางเรียบร้อย"
      }
    },
    "signoff": {
      "title": "ลงนามโดยแพทย์เจ้าของไข้",
      "instructions": "ทบทวนสรุปการจำหน่ายด้านล่างและให้แพทย์เจ้าของไข้ลงนาม",
      "diagnosisHeading": "การวินิจฉัยตอนจำหน่าย",
      "notProvided": "ไม่ได้ระบุ",
      "medicationsHeading": "ยาที่จ่ายตอนจำหน่าย",
      "noMedications": "ไม่มีรายการยาที่ต้องตรวจสอบ",
      "signedCompleted": "แพทย์เจ้าของไข้ลงนามเรียบร้อย",
      "signAsAttending": "ลงนามในฐานะแพทย์เจ้าของไข้",
      "requiresAttendingSignoff": "ต้องการการลงนามของแพทย์เจ้าของไข้"
    },
    "review": {
      "title": "ทบทวนและยืนยันการจำหน่าย",
      "summaryHeading": "สรุปการจำหน่าย",
      "fields": {
        "diagnosis": "การวินิจฉัย:",
        "procedures": "หัตถการ:",
        "condition": "อาการ:",
        "provider": "แพทย์:",
        "date": "วันที่:",
        "notes": "หมายเหตุ:",
        "general": "ทั่วไป:",
        "diet": "อาหาร:",
        "activity": "กิจกรรม:",
        "warningSigns": "อาการเตือน:"
      },
      "medicationsHeading": "การตรวจสอบยา",
      "noMedications": "ไม่มีรายการยาที่ต้องตรวจสอบ",
      "followupHeading": "นัดติดตาม",
      "instructionsHeading": "คำแนะนำสำหรับผู้ป่วย",
      "noInstructions": "ยังไม่ได้กรอกคำแนะนำ",
      "pendingOrdersWarning": "อาจมีคำสั่งที่ยังไม่เสร็จหรือบันทึกที่ยังไม่ลงนาม กรุณาตรวจสอบก่อนจำหน่าย",
      "diagnosisRequired": "ต้องกรอกการวินิจฉัยตอนจำหน่ายก่อนจึงจะจำหน่ายได้",
      "empty": "--"
    },
    "nav": {
      "previous": "ก่อนหน้า",
      "next": "ถัดไป",
      "complete": "เสร็จสิ้นการจำหน่าย"
    },
    "toast": {
      "success": "จำหน่ายผู้ป่วยเรียบร้อย",
      "error": "ไม่สามารถจำหน่ายผู้ป่วยได้"
    }
  },
  "components": {
    "transferDialog": {
      "title": "ย้ายเคสรักษา",
      "description": "ย้ายผู้ป่วยไปยังตำแหน่งอื่นภายในสถานพยาบาล",
      "targetLocationLabel": "ตำแหน่งปลายทาง",
      "loadingLocations": "กำลังโหลดตำแหน่ง…",
      "selectLocation": "เลือกตำแหน่ง",
      "emptyState": "ไม่มีตำแหน่งที่ใช้งานอยู่อื่นในสถานพยาบาลนี้",
      "reasonLabel": "เหตุผล",
      "reasonPlaceholder": "เช่น ต้องการแยกผู้ป่วย, ลดระดับจาก ICU, เตียงเฝ้าระวังสูงกว่า",
      "actions": {
        "transfer": "ย้าย"
      },
      "toasts": {
        "success": "ย้ายเคสรักษาเรียบร้อย",
        "error": "ไม่สามารถย้ายเคสรักษาได้"
      }
    },
    "assignAttendingDialog": {
      "title": "มอบหมายแพทย์เจ้าของไข้",
      "description": "กำหนดแพทย์เจ้าของไข้ที่รับผิดชอบการรับรักษาครั้งนี้",
      "providerLabel": "แพทย์เจ้าของไข้",
      "loadingProviders": "กำลังโหลดรายชื่อแพทย์…",
      "selectProvider": "เลือกแพทย์",
      "emptyState": "สถานพยาบาลนี้ไม่มีแพทย์ที่ปฏิบัติงานอยู่",
      "actions": {
        "assign": "มอบหมาย"
      },
      "toasts": {
        "success": "มอบหมายแพทย์เจ้าของไข้แล้ว",
        "error": "ไม่สามารถมอบหมายแพทย์เจ้าของไข้ได้"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "ว่าง",
        "occupied": "ใช้งาน",
        "reserved": "จอง",
        "cleaning": "ทำความสะอาด",
        "closed": "ปิด",
        "isolated": "แยกกัก",
        "contaminated": "ปนเปื้อน"
      },
      "acuityLegendLabel": "ระดับ ESI:",
      "empty": "ยังไม่ได้กำหนดหน่วย",
      "summary": {
        "available_one": "ว่าง {{count}}",
        "available_other": "ว่าง {{count}}",
        "occupied_one": "ใช้งาน {{count}}",
        "occupied_other": "ใช้งาน {{count}}",
        "reserved_one": "จอง {{count}}",
        "reserved_other": "จอง {{count}}",
        "cleaning_one": "ทำความสะอาด {{count}}",
        "cleaning_other": "ทำความสะอาด {{count}}",
        "closed_one": "ปิด {{count}}",
        "closed_other": "ปิด {{count}}",
        "isolated_one": "แยกกัก {{count}}",
        "isolated_other": "แยกกัก {{count}}",
        "contaminated_one": "ปนเปื้อน {{count}}",
        "contaminated_other": "ปนเปื้อน {{count}}"
      }
    },
    "protocolPanel": {
      "title": "การลงทะเบียนโปรโตคอล",
      "enroll": "ลงทะเบียน",
      "availableProtocols": "โปรโตคอลที่ใช้ได้",
      "loadingProtocols": "กำลังโหลดโปรโตคอล...",
      "noProtocols": "ไม่มีโปรโตคอลที่ใช้ได้",
      "stepBadge": "ขั้นตอน {{current}}/{{total}}",
      "loadingEnrollments": "กำลังโหลดการลงทะเบียน...",
      "noEnrollments": "ไม่มีการลงทะเบียนโปรโตคอลที่ใช้งานอยู่",
      "completeStep": "ทำขั้นตอนให้เสร็จ",
      "toasts": {
        "enrollSuccess": "ลงทะเบียนโปรโตคอลแล้ว",
        "enrollError": "ลงทะเบียนโปรโตคอลไม่สำเร็จ",
        "advanceSuccess": "ขั้นตอนเสร็จสมบูรณ์",
        "advanceError": "ดำเนินขั้นตอนไม่สำเร็จ"
      }
    }
  }
}
